import React from "react";
import "./yourbanktransferModal.scss";
import { Col, Row } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { Link } from "react-router-dom";
import { hasContextPath } from "../../helpers/helpers";

const YourBankTransferModal = (props) => {
  const handleUpdateBankDetails = () => {
    window.open(hasContextPath() + "/account-details#banking", "_blank");
  };

  return (
    <div className="btm-parent">
      <Row className="mb-3">
        <Col>
          <div className="btm-small-close">
            <Link to="">
              <Icons
                iconname="close"
                variant="icon-sixteen-px"
                clickHandler={props.handleCloseButton}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <Row className="btm-title mb-3">
        <Col>
          <div>{props.modalTitle}</div>
        </Col>
      </Row>
      <Row className="btm-sub-title mb-5">
        <Col>
          <div className="mb-3">
            Your money will be sent to the same bank account that we have
            recorded in your Personal details.
          </div>
          <div className="mb-3">
            If you need to update your bank details, please do this now before
            continuing with this withdrawal request.
          </div>
          <div>
            <Row style={{ paddingLeft: "0px" }}>
              <Col lg={12}>
                <Buttons
                  name="Update bank details"
                  className="tertiary"
                  handleClick={handleUpdateBankDetails}
                ></Buttons>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col xl={12} lg={12} md={12}>
          <div className="btm-button">
            <Buttons
              name="Continue"
              className="primary"
              variantname="icon-sixteen-px"
              handleClick={props.handleContinue}
            ></Buttons>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default YourBankTransferModal;
